import { normalizeDirectorNoteDraft, normalizeVisibilityCount } from '@/features/story-conversation/directorNotes'
import type { DirectorNoteDraft } from '@/features/story-conversation/directorNotes'
import type { DirectorNotePlacement } from '@/types/domain'
import { createBlankChatComposerState, type ChatComposerState } from '@/components/chat/composerState'
export { createBlankChatComposerState, type ChatComposerState } from '@/components/chat/composerState'

export interface DirectorNoteFromComposer {
  content: string
  placement: DirectorNotePlacement
  visibility_count: number | null
}

export function buildDirectorNoteFromComposerState(state: ChatComposerState | null | undefined): DirectorNoteFromComposer | null {
  const noteContent = state?.note?.trim?.() || ''
  if (!noteContent) return null

  return {
    content: noteContent,
    placement: state?.placement === 'prepend' ? 'prepend' : 'append',
    visibility_count: state?.expires
      ? normalizeVisibilityCount(state?.life) ?? 1
      : null,
  }
}

export function buildChatComposerStateFromDraft({
  text = '',
  directorNote = null,
}: {
  text?: string
  directorNote?: DirectorNoteDraft | Record<string, unknown> | null
}): ChatComposerState {
  const base = createBlankChatComposerState()
  const noteDraft = normalizeDirectorNoteDraft(directorNote)
  const nextState: ChatComposerState = {
    ...base,
    message: typeof text === 'string' ? text : '',
  }

  if (noteDraft?.content?.trim?.()) {
    nextState.note = noteDraft.content
    nextState.placement = noteDraft.placement === 'prepend' ? 'prepend' : 'append'
    nextState.expires = noteDraft.visibility_count !== null
    nextState.life = noteDraft.visibility_count ?? base.life
  }

  return nextState
}
